<template>
  <div v-if="storedProcedures">
    <div v-for="(table, index) in tables" :key="'table-' + index" class="mb-5">
      <v-card flat>
        <v-card-title>
          <span class="font-weight-bold">{{ table.tableTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-row >
            <v-col cols="12" sm="2">
              <v-text-field
                v-model="table.filter"
                label="Pesquisar"
                clearable
                class="mb-3"
                hide-details
                prepend-icon="mdi-magnify"
                dense
              />
            </v-col>
            <v-col cols="12" sm="2">
              <v-menu
                ref="startDateMenu"
                v-model="table.startDateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="table.startDate"
                    label="Data Inicial"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    hide-details
                    dense
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="table.startDate"
                  @input="table.startDateMenu = false;"
                  locale="pt-BR"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="2">
              <v-menu
                ref="endDateMenu"
                v-model="table.endDateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="table.endDate"
                    label="Data Final"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    hide-details
                    dense
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="table.endDate"
                  @input="table.endDateMenu = false;"
                  locale="pt-BR"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="2" >
              <v-btn
                prepend-icon="mdi-magnify"
                small
                color="default"
                class="ml-2"
                @click="updateTableData(index)"
                
              >
                Filtrar
              </v-btn>
            </v-col>
            <v-col cols="12" sm="3">
               <div class="d-flex align-center" style="gap: 8px;">
                <v-select
                  :visible="visibilityStatus"
                  v-model="table.statusId"
                  :items="statusOptions"
                  label="Status"
                  @change="updateTableData(index)"
                  dense
                  hide-details
                  style="width: 180px; max-width: 180px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
                ></v-select>
                <v-btn
                  small
                  color="default"
                  class="ml-2"
                  @click="clearStatus(index)"
                  
                >
                  Limpar
                </v-btn>
              </div>
            </v-col>
          </v-row>
          <v-data-table
            :headers="table.headers"
            :items="formatTableData(table)"
            class="elevation-1"
            dense
            height="300"
            :items-per-page="-1"
          ></v-data-table>
          <v-row justify="end" class="mt-4">
            <v-col cols="auto">
              <v-btn small color="primary" @click="exportTableCSV(index)">
                Exportar CSV
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: "DynamicDataTable",
    props: {
      storedProcedures: {
        type: Object,
        required: true
      }  
    },
    data() {
        return {
            activeTab: 0,
            tables: [],
            statusOptions: [
            ],
            visibilityStatus: true
        };
    },
    computed:{
        ...mapGetters(['getReportSalesGeneralList']),
        ...mapGetters(['getStatusLists']),
        ...mapGetters(['getListReports']),
        ...mapGetters(['getIndexReport']),
        currentCustomerId() {
            return this.$store.state.currentCustomerId;
        },        
    },
    methods: {
        formatCurrency(value) {
          try {
           if (value === null || value === undefined || value === '') return '-';
             
              var ret = value.toLocaleString('pt-BR', { 
                style: 'currency', 
                currency: 'BRL'
              });
              console.log('Valor formatado:', ret);
              return ret; 
            } catch (e) {
            console.error('Erro ao formatar valor monetário:', e);
            return value;
          }
        },
        isMonetaryColumn(columnName) {
          const monetaryPatterns = [
            'valor',
            'pago',            
            'price',
            'amount',
            'preço',
            'custo',
            'taxa',
            'fee',
            'desconto',
            'acrescimo',
            'reembolso',
            'credito',
            'debito',
            'saldo',
            'revenue'
          ];
          const lowerName = columnName.toLowerCase();
          return monetaryPatterns.some(pattern => lowerName.includes(pattern));
        },
        clearStatus(index) {
          this.tables[index].statusId = 0;
          this.updateTableData(index);
        },
        exportTableCSV(index) {
          const table = this.tables[index];
          if (!table.items || table.items.length === 0) return;

          
          const headers = table.headers.map(h => h.text).join(';');
          
          const rows = table.items.map(item =>
            table.headers.map(h => {
              const value = item[h.value] != null ? item[h.value] : '';
              //garantir que mantem as casas decimais
              if (this.isMonetaryColumn(h.value)) {
                const numValue = typeof value === 'string' ? parseFloat(value.replace(/\D/g, '')) / 100 : parseFloat(value);
                if (!isNaN(numValue)) {
                  return `"${numValue.toFixed(2).replace('.', ',')}"`;
                }
              }
              return `"${value}"`;
            }).join(';')
          );
          
          const csvContent = [headers, ...rows].join('\n');

          
          const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.setAttribute('download', `${table.tableTitle || table.key}.csv`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        },
        async generateTables() {
          this.tables = [];

          if (!this.storedProcedures.report_Data || !this.currentCustomerId) {
              console.log('Aguardando stored procedures e customer ID...');
              return;
          }

          
          await this.$store.dispatch('getTripStatusList', localStorage.getItem("customer_Id")); 
          this.statusOptions = this.getStatusLists.map(status => ({
              text: status.status_Description,   
              value: status.status_Id
          }));
          var reports = this.storedProcedures.report_Data;
          const report = reports
              .split(";")
              .map(k => k.trim())
              .filter(k => k);

          for (let item of report) {
            const [spName, tableTitle] = item.split("::");
            const today = new Date().toISOString().split("T")[0];
            try {
              
              const generalData = {
                customerId: this.currentCustomerId,
                startDate: today,
                endDate: today,
                statusId: 0,
                storedProcedureName: spName
              };
              console.log('titulo tabela', tableTitle);
              await this.$store.dispatch("getGeneralSalesList", generalData);
              const apiData = this.getReportSalesGeneralList;
              console.log('dados api', apiData);
              let headers = [];
              if (apiData && apiData.length > 0) {
                headers = Object.keys(apiData[0]).map(col => ({
                  text: col,
                  value: col
                }));
              }
              else{
                headers = [{ text: 'Sem dados', value: 'no_data' }];
              }

              this.tables.push({
                  key: spName,
                  tableTitle,
                  headers: headers,
                  items: apiData,
                  filter: "",
                  startDate: today,
                  endDate: today,
                  startDateMenu: false,
                  endDateMenu: false,
                  statusId: 0
                });

            } catch (err) {
              console.error(`Erro ao buscar dados para ${item}:`, err);
              this.tables.push({
                key: spName,
                tableTitle,
                headers: [],
                items: [],
                filter: "",
                startDate: today,
                endDate: today,
                startDateMenu: false,
                endDateMenu: false,
                statusId: 0
              });
            }
          }
          if (this.storedProcedures.report_Parameter == "nostatus") {
              this.visibilityStatus = false;
          }
        },
        filteredItems(table) {
            if (!table.filter) return table.items;
            const term = table.filter.toLowerCase();
            return table.items.filter(item =>
                Object.values(item).some(val =>
                String(val).toLowerCase().includes(term)
                )
            );
        },
        formatTableData(table) {
          if (!table.filter && !table.items) return [];
          
          const filteredData = this.filteredItems(table);
          
          return filteredData.map(item => {
            const formattedItem = { ...item };
            table.headers.forEach(header => {
              if (this.isMonetaryColumn(header.value) && formattedItem[header.value] !== null && formattedItem[header.value] !== undefined) {
                formattedItem[header.value] = this.formatCurrency(item[header.value]);
              }
            });
            return formattedItem;
          });
        },
        async updateTableData(index) {
          const table = this.tables[index];
          const generalData = {
            customerId: this.currentCustomerId,
            startDate: table.startDate,
            endDate: table.endDate,
            statusId: table.statusId,
            storedProcedureName: table.key
          };
          console.log('Atualizando dados da tabela com filtros:', generalData);
          await this.$store.dispatch("getGeneralSalesList", generalData);
          const apiData = this.getReportSalesGeneralList;
          console.log('Dados retornados da API:', apiData);
          if (apiData && apiData.length > 0) {
            this.tables[index].items = apiData;
            this.tables[index].headers = Object.keys(apiData[0]).map(col => ({
              text: col,
              value: col
            }));
          } else {
            this.tables[index].items = [];
            console.warn('Nenhum dado  API.');
          }
        }
    },
    watch: {
        storedProcedures: {
            handler(newValue) {
                if (newValue) {
                    this.generateTables();
                }
            },
            immediate: true
        },
        currentCustomerId: {
            handler(newCustomerId) {
                if (newCustomerId && this.storedProcedures) {
                    this.generateTables();
                }
            }
        }
    }
};
</script>
